import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface FavoritesStore {
  favoriteIds: string[];
  
  // Actions
  addFavorite: (productId: string) => void;
  removeFavorite: (productId: string) => void;
  toggleFavorite: (productId: string) => void;
  isFavorite: (productId: string) => boolean;
  getFavoriteCount: () => number;
  clearFavorites: () => void;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      favoriteIds: [],

      addFavorite: (productId) => {
        const { favoriteIds } = get();
        if (!favoriteIds.includes(productId)) {
          set({ favoriteIds: [...favoriteIds, productId] });
        }
      },

      removeFavorite: (productId) => {
        set({
          favoriteIds: get().favoriteIds.filter(id => id !== productId)
        });
      },

      toggleFavorite: (productId) => {
        const { favoriteIds, addFavorite, removeFavorite } = get();
        if (favoriteIds.includes(productId)) {
          removeFavorite(productId);
        } else {
          addFavorite(productId);
        }
      },

      isFavorite: (productId) => {
        return get().favoriteIds.includes(productId);
      },

      getFavoriteCount: () => {
        return get().favoriteIds.length;
      },

      clearFavorites: () => {
        set({ favoriteIds: [] });
      },
    }),
    {
      name: 'nathof-favorites',
      storage: createJSONStorage(() => localStorage),
    }
  )
);